/* KB Hero-Slider (Spec 06) — sanfte Überblendung, Punkte-Navigation,
   Pause bei Hover/Fokus, kein Autoplay bei prefers-reduced-motion. */
(function () {
  'use strict';

  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-kb-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kb-dot]'));
    var interval = parseInt(root.dataset.kbAutoplay || '6', 10) * 1000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    /* Slide-Fotos laden erst, wenn sie gebraucht werden: bei schwacher Leitung
       kommt so zuerst das sichtbare Bild und nicht alle drei auf einmal */
    function loadImage(slide) {
      var img = slide.querySelector('img[data-kb-src]');
      if (!img) return;
      img.srcset = img.dataset.kbSrcset;
      img.src = img.dataset.kbSrc;
      img.removeAttribute('data-kb-src');
    }

    function show(index) {
      current = (index + slides.length) % slides.length;
      loadImage(slides[current]);
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        var video = slide.querySelector('video');
        if (video) {
          if (active && !reduceMotion) video.play().catch(function () {});
          else video.pause();
        }
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    function start() {
      if (reduceMotion || interval <= 0 || timer) return;
      timer = setInterval(function () { show(current + 1); }, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stop(); show(i); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();

    /* Nächsten Slide vorladen, sobald die Seite fertig ist */
    function preloadNext() {
      loadImage(slides[(current + 1) % slides.length]);
      setTimeout(function () { slides.forEach(loadImage); }, interval);
    }
    if (document.readyState === 'complete') preloadNext();
    else window.addEventListener('load', preloadNext);
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-kb-slider]')).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
